module.exports = __webpack_public_path__ + "img/DefaultProfileCover.cc685ea4.png";